// Keeps one cart drawer: EasyCart. The theme drawer stays in the page, but only opens if EasyCart is unavailable,
// so customers always have a working cart even if the EasyCart subscription lapses.
(() => {
  let expired = false;
  document.addEventListener('easycart:access-expired', () => { expired = true; });

  const dialog = () => document.getElementById('easycart-dialog');
  const easyCartLive = () => !expired && !!dialog();

  function takeOverThemeDrawer() {
    const proto = window.theme?.CartDrawer?.prototype;
    if (!proto || proto.__easyCartOnly) return;
    const themeOpen = proto.open;
    proto.__easyCartOnly = true;
    proto.open = function (...args) {
      if (easyCartLive()) return undefined;
      return themeOpen.apply(this, args);
    };
  }

  takeOverThemeDrawer();
  document.addEventListener('DOMContentLoaded', takeOverThemeDrawer);

  // EasyCart opens itself after an add. If it has not within a moment, open it through its cart link.
  document.addEventListener('ajaxProduct:added', () => {
    if (!easyCartLive()) return;
    setTimeout(() => {
      if (dialog().open) return;
      document.querySelector('a[href$="/cart"]')?.click();
      try { sessionStorage.removeItem('easycart-open'); } catch {}
    }, 1200);
  });
})();
